import BaseModel from './BaseModel';

export default class NAICCodeModel extends BaseModel {
  init(data) {
    this.code = data.code || 0;
    this.name = data.name || '';
  }
}
